export default __webpack_public_path__ + "static/media/nubrakes-logo@white.c3c34c81.svg";